import { downloadBlob, fetchSameOrigin } from '../../Utils';

const DEFAULT_CCR_FILE_NAME = 'ccr.pdf';
const CCR_FILE_TYPE = 'pdf';

function downloadCCR(memberId, ccrConsultation) {
  const {
    actorId,
    actorType,
  } = ccrConsultation;

  return fetchSameOrigin(`/members/${memberId}/health_record?actor_id=${actorId}&actor_type=${actorType}&file_type=${CCR_FILE_TYPE}`, 'GET')
    .then((response) => (
      response.blob()
        .then((blob) => {
          const contentHeader = response.headers.get('Content-Disposition');
          const filename = window.decodeURIComponent(contentHeader.match(/filename="(.*?)"/)[1]);

          if (filename) {
            downloadBlob(blob, filename);
          } else {
            downloadBlob(blob, DEFAULT_CCR_FILE_NAME);
          }
        })
    ));
}

export default downloadCCR;
